import React from 'react';
import { ArrowRightIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';

import styles from './index.module.scss';

const OtmRecBanner = () => {
  const t = useTranslations('home.otm_rec_banner');

  return (
    <div className={`${styles.customBackground} mb-10 p-4 pb-0 shadow-md rounded-2xl`}>
      <div className="mx-5 flex max-w-screen flex-col-reverse items-center md:mx-auto md:flex-row">
        <div className="w-full md:w-[50%] xl:w-[55%]">
          <Image
            src="/images/students-image.webp"
            alt="Studentlar rasmi"
            width={890}
            height={350}
            loading="lazy"
            title="studentlar rasmi"
            className="h-auto w-full"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 50vw"
          />
        </div>

        <div className="flex w-full flex-col items-center justify-center p-4 text-center text-white md:w-1/2 md:text-left lg:w-[40%] xl:w-[45%]">
          <h2 className="break-words text-center text-3xl font-bold md:text-4xl lg:text-[2.5rem]">{t('main_title')?.toUpperCase()}</h2>
          <p className="my-5 text-sm font-medium md:text-base">{t('desc')}</p>
          <Link
            href={globalConst.pageNames.OTM_LIST}
            className="rounded-lg border-none flex font-medium items-center px-3 gap-2 bg-white py-2 text-indigo-600 transition-transform duration-200 hover:scale-110 hover:border-none"
          >
            {t('button_title')}
            <ArrowRightIcon />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OtmRecBanner;
